import {useEffect, useState} from "react";
import {useForm, Controller, useWatch} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {Col, Row} from "antd";
import {
	Button,
	Loading
} from "~/components";
import {
	GroupRadioField,
	SelectField,
	InputField,
	DateField
} from "~/components/Forms";
import {
	provinceChange
} from "~/utils";

import {useProvince} from "../../../../hooks";
import {getWardOptionByProvinceId} from "../../../../utils";

function BuyServiceFormEdit({item, onHandleSubmit}) {

	let provinceOptions = useProvince();

	let [wardOptions, setWardOptions] = useState([{
		value: 0,
		label: "Chọn phường xã"
	}]);

	let [wardCompanyOptions, setWardCompanyOptions] = useState([]);

	const forOptions = [
		{value: 'canhan', label: 'Cá Nhân'},
		{value: 'congty', label: 'Công Ty'},
	];

	const genderOptions = [
		{value: 'Nữ', label: 'Nữ'},
		{value: 'Nam', label: 'Nam'},
	];

	const initialValues = {
		for: undefined,
		companyName: '',
		companyAddress: undefined,
		companyProvince: undefined,
		companyWard: undefined,
		taxCode: undefined,
		name: undefined,
		numberId: undefined,
		email: undefined,
		phone: undefined,
		province: 0,
		ward: 0,
		birthday: undefined,
		gender: 'Nam',
	}

	const validationSchema = Yup.object().shape({
		for: Yup.string().required('Bạn chưa chọn loại khách hàng'),
		companyName: Yup.string().when('for', {
			is: 'congty',
			then: Yup.string().required('Tên công ty không được bỏ trống'),
		}).nullable(),
		companyAddress: Yup.string().when('for', {
			is: 'congty',
			then: Yup.string().required('Địa chỉ công ty không được bỏ trống'),
		}),
		companyProvince: Yup.string().when('for', {
			is: 'congty',
			then: Yup.string().required('Bạn chưa chọn tỉnh thành công ty'),
		}),
		companyWard: Yup.string().when('for', {
			is: 'congty',
			then: Yup.string().required('Bạn chưa chọn phường xã công ty'),
		}),
		taxCode: Yup.string().when('for', {
			is: 'congty',
			then: Yup.string().required('Mã số thuế không được bỏ trống'),
		}).nullable(),
		name: Yup.string().required('Họ tên khách hàng không được để trống'),
		numberId: Yup.string().required('CCCD khách hàng không được để trống'),
		email: Yup.string().email('Email không đúng định dạng').required('Email không được để trống'),
		phone: Yup.string().required('Số điện thoại không được để trống'),
		province: Yup.string().required('Tỉnh thành không được để trống'),
		address: Yup.string().required('Địa chỉ không được để trống'),
		ward: Yup.string().required('Phường xã không được để trống'),
		birthday: Yup.string().required('Bạn chưa chọn ngày sinh khách hàng'),
		gender: Yup.string().required('Bạn chưa chọn giới tính khách hàng'),
	})

	const {control, handleSubmit, formState: {isSubmitting, errors}, reset, setValue} = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	const forInput = useWatch({control, name: "for"});

	useEffect(() => {
		if (item?.id) {
			initialValues.for = item.for;
			initialValues.companyName = item.companyName;
			initialValues.companyAddress = item.companyAddress;
			initialValues.companyProvince = item.companyProvince;
			initialValues.companyWard = item.companyWard;
			initialValues.taxCode = item.taxCode;
			initialValues.name = item.name;
			initialValues.numberId = item.numberId;
			initialValues.email = item.email;
			initialValues.phone = item.phone;
			initialValues.address = item.address;
			initialValues.province = item.province;
			initialValues.ward = item.ward;
			initialValues.birthday = item.birthday*1000;
			initialValues.gender = item.gender;

			async function loadLocation(item) {
				if (item?.province !== 0)
				{
					// eslint-disable-next-line react-hooks/exhaustive-deps
					wardOptions = await getWardOptionByProvinceId(item.province)
					setWardOptions(wardOptions);
				}
			}

			loadLocation(item);
		}
		reset(initialValues);
	}, [item?.id]);

	const handleProvinceChange = async (value) =>
	{
		await provinceChange({
			value,
			setWardOptions: setWardOptions,
			setValue: function ()
			{
				setValue('ward', 0);
			}
		})
	}

	const handleCompanyProvinceChange = async (value) => {
		await provinceChange({
			value,
			setDistrictOptions: setWardCompanyOptions,
			setValue: function () {
				setValue('companyWard', 0);
			}
		})
	}

	const renderInfo = () => {
		return (
			<>
				<Controller control={control} name="for" render={({field}) => (
					<GroupRadioField options={forOptions} errors={errors} {...field}/>
				)}/>
				{renderCompanyInfo(forInput)}
				<Row gutter={10}>
					<Col className="gutter-row" span={12}>
						<Controller control={control} name="name" render={({field}) => (
							<InputField label="Họ tên khách hàng (Người đại diện)" errors={errors} {...field}/>
						)}/>
					</Col>
					<Col className="gutter-row" span={12}>
						<Controller control={control} name="numberId" render={({field}) => (
							<InputField label="CCCD / CMND" errors={errors} {...field}/>
						)}/>
					</Col>
				</Row>
				<Row gutter={10}>
					<Col className="gutter-row" span={12}>
						<Controller control={control} name="email" render={({field}) => (
							<InputField type="email" label="Email liên hệ" errors={errors} {...field}/>
						)}/>
					</Col>
					<Col className="gutter-row" span={12}>
						<Controller control={control} name="phone" render={({field}) => (
							<InputField type="tel" label="Số điện thoại" errors={errors} {...field}/>
						)}/>
					</Col>
				</Row>
				<Row gutter={10}>
					<Col className="gutter-row" span={24}>
						<Controller control={control} name="address" render={({field}) => (
							<InputField label="Địa chỉ" errors={errors} {...field}/>
						)}/>
					</Col>
				</Row>
				<Row gutter={10}>
					<Col className="gutter-row" span={12}>
						<Controller control={control} name="province" render={({field}) => (
							<SelectField placeholder="Chọn tỉnh thành" options={provinceOptions} errors={errors} {...field}
										 onChange={(value, event) => {
											 handleProvinceChange(value);
											 field.onChange(value, event);
										 }}/>
						)}/>
					</Col>
					<Col className="gutter-row" span={12}>
						<Controller control={control} name="ward" render={({field}) => (
							<SelectField placeholder="Chọn phường xã" options={wardOptions} errors={errors} {...field}/>
						)}/>
					</Col>
				</Row>

				<Row gutter={10}>
					<Col className="gutter-row" span={12}>
						<Controller control={control} name="birthday" render={({field}) => (
							<DateField label="Ngày sinh" errors={errors} {...field}/>
						)}/>
					</Col>
					<Col className="gutter-row" span={12}>
						<Controller control={control} name="gender" render={({field}) => (
							<SelectField label="Giới tính" options={genderOptions} errors={errors} {...field}/>
						)}/>
					</Col>
				</Row>
			</>
		)
	}

	const renderCompanyInfo = (forValue) => {
		if ((forValue === 'congty')) return (
			<>
				<p className="heading">Thông tin công ty</p>
				<Row gutter={10}>
					<Col className="gutter-row" span={12}>
						<Controller control={control} name="companyName" render={({field}) => (
							<InputField label="Tên công ty" errors={errors} {...field}/>
						)}/>
					</Col>
					<Col className="gutter-row" span={12}>
						<Controller control={control} name="taxCode" render={({field}) => (
							<InputField label="Mã số thuế" errors={errors} {...field}/>
						)}/>
					</Col>
				</Row>
				<Row gutter={10}>
					<Col className="gutter-row" span={24}>
						<Controller control={control} name="companyAddress" render={({field}) => (
							<InputField label="Địa chỉ" errors={errors} {...field}/>
						)}/>
					</Col>
				</Row>
				<Row gutter={10}>
					<Col className="gutter-row" span={8}>
						<Controller control={control} name="companyProvince" render={({field}) => (
							<SelectField placeholder="Chọn tỉnh thành" options={provinceOptions} errors={errors} {...field}
										 onChange={(value, event) => {
											 handleCompanyProvinceChange(value);
											 field.onChange(value, event);
										 }}/>
						)}/>
					</Col>
					<Col className="gutter-row" span={8}>
						<Controller control={control} name="companyWard" render={({field}) => (
							<SelectField placeholder="Chọn phường xã" options={wardCompanyOptions}
										 errors={errors} {...field}/>
						)}/>
					</Col>
				</Row>
				<p className="heading">Thông tin người đại diện</p>
			</>
		)
	}

	const onSubmit = async (data) => {
		await onHandleSubmit(data, item);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<p className="heading">Thông tin</p>
			{renderInfo()}
			<hr/>
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">Cập nhật yêu cầu</Button>
			</div>
		</form>
	)
}

export default BuyServiceFormEdit;